module.exports = __webpack_public_path__ + "img/coag-residual-tissue.bd439246.jpg";